<template>
 
<div style="height: 100%;width: 100%;">
    <div class="block" style="height:auto;width: 100%;position: relative;">
        <br/><br/><br/>
        <div style="display: flex;">
            <el-image :src="require('@/assets/Home.png')" style="width: 50%;height:60%;margin-right: 3%;"> </el-image>
            <div style="width: 45%;">
                <h1 style="text-align:left">What is MDDOmics?</h1>
                <div style="font-size:20px;text-align: left;line-height: 30px;margin-left:2%">
                    <strong style="font-size:25px;">MDDOmics</strong>
                    (<strong>M</strong>ajor
                    <strong>D</strong>epressive 
                    <strong>D</strong>isorder 
                    <strong>Omics</strong>) integrates
                    multi-omics data including the genome, transcriptome, epigenome and metabolome data 
                    based on reported experimental results from different databases or literature
                    about the major depressive disorder(MDD) and 
                    its similar psychiatric disorders bipolar disorder(BD), schizophrenia(SZ), anxiety disorder(AX).
                    <br/>
                    <br/>
                    Downstream analysis results including enrichment analysis, differential analysis
                    and MDD disease gene prediction were also presented for further understand.
                    Multiple search and visualization tools 
                    make the data in MDDOmics to be applied to a broad range of research easily.<br/><br/>
                </div >
            </div>
        </div>
        <br/>
        <div 
            style="height:auto;
            width:auto;
            margin-top: 20px;
            padding-left:2.5%;
            padding-right:2.5%;
            padding-top: 1%;
            padding-bottom: 1%;
            z-index: 100;">

            <h1 style="text-align:left">What does MDDOmics have?</h1>
            <div style="display: flex;">
                <el-card class="box-card" style="width:30%; margin-right:1.5%;">
                <p class="box-title">
                    <b>Data</b>
                </p><br/>
                <el-image class="box-img" :src="require('@/assets/Data.png')" style="width:250px;display: block;margin:auto"/>
                <div style="padding:4%;line-height:30px">
                    Public data related to four psychiatric disorders (
                        <a href="#/browse/MDD">MDD</a>, 
                        <a href="#/browse/BD">BD</a>, 
                        <a href="#/browse/SZ">SZ</a> and 
                        <a href="#/browse/AX">AX</a>) 
                    across six omics categories (
                        <a href="#/search/snp">SNPs</a>, 
                        <a href="#/search/gene">genes</a>,
                        <a href="#/search/rna">ncRNAs</a>, 
                        <a href="#/search/methylation">DNA methylations</a>, 
                        <a href="#/search/metabolite">metabolites</a> and 
                        <a href="#/search/protein">proteins</a>)
                     were collected and annotated from multiple databases and literature sources.<br/><br/>
                </div>
                
                
                </el-card>
                <el-card class="box-card" style="width:30%;margin-right:1.5%;">
                    <p class="box-title">
                        <b>Analysis</b><br>
                    </p><br/>
                    <el-image class="box-img" :src="require('@/assets/Analysis.png')" style="width:260px;display: block;margin:auto"/>
                    <div style="padding:4%">
                        Extensive downstream analyses results of the collected MDD data.<br/><br/>
                        <a href="#/analysis/differential/expression">Difference</a>: Differential analysis on gene expression and DNA methylation profile.<br/>
                        <br/><a href="#/analysis/enrichment/conventional">Enrichment</a>: GO and KEGG pathway enrichment results using conventional and WEAT methods.<br/>
                        <br/><a href="#/analysis/prediction">Prediction</a>: Prediction results of MDD disease genes and ncRNAs using a network impulsive dynamics-based approach.
                        
                        
                    </div>
                </el-card>
                <el-card class="box-card" style="width:30%;">
                    <p class="box-title">
                        <b>Visualization</b><br>
                    </p>
                    <br/><br/>
                    <el-image class="box-img" :src="require('@/assets/Visualization2.png')" style="width:260px;display: block;margin:auto"/>
                    <div style="padding:4%">
                        <br/>Three visualization interfaces for a more graphical understanding of MDD.<br/><br/>
                        <a href="#/visualization/ppi">PPI</a>: Protein-Protein Interaction network from STRING database of the collected MDD-related genes. <br/>
                        <br/><a href="#/visualization/relation">Relation</a>: Show the cross-analysis of four psychiatric disorders from the perspectives of both diseases and biological factors.<br/>
                        <br/><a href="#/visualization/location">Location</a>: View of the chromosomal locations of biological factors from four omics related to MDD.<br/>
                    </div>
                </el-card>
            </div>
           
        </div>
    </div>
   
  
</div>

</template>


<script>

export default({
    methods:{
//         imgLoad(){
//             this.$nextTick(()=>{
//             this.bannerHeight=this.$refs.bannerHeight[0].height
//         }
//         )
// }

    },
    data(){
        return{
            bannerHeight: "",
            picAddress:[{id:0,idView:require('@/assets/Home.png')},
                    {id:1,idView:require('@/assets/Home2.png')},
                    {id:2,idView:require('@/assets/Home3.png')}
            ]
        }
        
    },
    mounted() {
        // this.imgLoad();
        window.addEventListener( 'resize',()=> {
        this.bannerHeight=this.$refs.bannerHeight[0].height
        // this.imgLoad();
    },false)}
})
</script>

<style scoped>
.box-img{
    width:100%;
    vertical-align:middle;
    display:inline-block;
}
.box-card{
    width:auto;
    height:auto;
    margin-left:3.5%;
    margin-right: 3.5%;
    text-align: left;    
}
.box-title{
    margin: 0;
    text-align: center;
    font-size:18px;
    height: 25px;
}
.el-card ::v-deep .el-card__body {
  padding: 1%;
  height:100%;
}
.el-carousel{
    width: 100%
}
.el-carousel el-carousel--horizontal{
    height:500px !important;
}
.el-carousel__container{
    height:500px !important;
}

/deep/.el-carousel__indicators {
  left: unset;
  transform: unset;
  top: 1%;
  right: 45%;
  left: auto;
}
/deep/.el-carousel__indicator.is-active button { 
  width: 36px;
  height: 8px;
  border: none;
  border-radius: 20px;
  background: rgb(217,117,2);
  opacity: 1;
}

/deep/ .el-carousel__button {
  width: 36px;
  height: 8px;
  border: none;
  border-radius: 20px;
  background: #FFFFFF;
  opacity: 1;
}

</style>
